import * as newDashboardTypes from './newDashboardTypes';

export const setComposeClick = payload => {
  return {
    type: newDashboardTypes.SET_COMPOSE_CLICK,
    payload,
  };
};

export const setCaseId = payload => {
  return {
    type: newDashboardTypes.SET_CASE_ID,
    payload,
  };
};

export const setCaseNumber = payload => {
  return {
    type: newDashboardTypes.SET_CASE_NUMBER,
    payload,
  };
};

export const setCaseDetail = payload => {
  return {
    type: newDashboardTypes.SET_CASE_DETAIL,
    payload,
  };
};

export const resetCaseDetail = () => {
  return {
    type: newDashboardTypes.RESET_CASE_ID,
  };
};

export const setCaseToggleOption = payload => {
  return {
    type: newDashboardTypes.SET_SELECTED_TOGGLE_OPTION,
    payload,
  };
};
export const resetCaseToggleOption = () => {
  return {
    type: newDashboardTypes.RESET_SELECTED_TOGGLE_OPTION,
  };
};
export const refreshUnReadMessage = payload => {
  return {
    type: newDashboardTypes.REFRESH_MESSAGE_COUNT,
    payload,
  };
};
